import {
  CLUB,
  CLUB_CASUAL,
  FOOTBALL_TYPE_ID,
  KICKABOUT_CASUAL,
} from '../../../const';
import publicPath from '../../../utils/publicPath';

export default [
  {
    id: '61459727-eb01-4eff-96d6-d677fdc63e3d',
    questionOrder: 3,
    readableId: FOOTBALL_TYPE_ID,
    type: 'multi_optional',
    title: 'What are you interested in playing?',
    helpText:
      'Sessional football that is not part of a competition, its non-comital, play based on your lifestyle.',
    helpTextSecondary:
      'Team-based football included training, games and competitions with a set start and end date.',
    multiOptional: {
      mandate: [
        {
          answerId: 5,
          analyticsId: 'casual_football',
          title: 'Sessional',
          answerType: 'primary',
          value: CLUB_CASUAL,
          image: publicPath('/images/common/cutouts/kickabout.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
      ],
    },
    answers: {
      mandatory: [
        {
          answerId: 1,
          analyticsId: 'casual_football',
          title: 'Sessional',
          value: KICKABOUT_CASUAL,
          answerType: 'primary',
          image: publicPath('/images/common/cutouts/kickabout.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
        {
          answerId: 2,
          analyticsId: 'club_football',
          title: 'Team',
          value: CLUB,
          answerType: 'primary',
          image: publicPath('/images/common/cutouts/male.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
      ],
      optional: {
        answerId: 3,
        analyticsId: 'mixed_football',
        title: 'Mixed football',
        answerType: 'primary',
        value: CLUB_CASUAL,
        image: publicPath('/images/common/cutouts/mixed-adult.png'),
        ageRanges: [
          {
            min: 0,
            max: 0,
            nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
          },
        ],
      },
    },
  },
  {
    id: '123735b9-f394-4e48-800b-a6fcfd9a479d',
    questionOrder: 3,
    readableId: FOOTBALL_TYPE_ID,
    type: 'multi_optional',
    title: 'What are you interested in playing?',
    helpText:
      'Sessional football that is not part of a competition, its non-comital, play based on your lifestyle.',
    helpTextSecondary:
      'Team-based football included training, games and competitions with a set start and end date.',
    multiOptional: {
      mandate: [
        {
          answerId: 5,
          analyticsId: 'casual_football',
          title: 'Sessional',
          answerType: 'primary',
          value: CLUB_CASUAL,
          image: publicPath('/images/common/cutouts/kickabout.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
      ],
    },
    answers: {
      mandatory: [
        {
          answerId: 1,
          analyticsId: 'casual_football',
          title: 'Sessional',
          value: KICKABOUT_CASUAL,
          answerType: 'primary',
          image: publicPath('/images/common/cutouts/casual.png'),
          keylineVariant: 2,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
        {
          answerId: 2,
          analyticsId: 'club_football',
          title: 'Team',
          value: CLUB,
          answerType: 'primary',
          image: publicPath('/images/common/cutouts/female.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
      ],
      optional: {
        answerId: 3,
        analyticsId: 'mixed_football',
        title: 'Mixed football',
        answerType: 'primary',
        value: CLUB_CASUAL,
        image: publicPath('/images/common/cutouts/mixed-adult.png'),
        ageRanges: [
          {
            min: 0,
            max: 0,
            nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
          },
        ],
      },
    },
  },
  {
    id: 'dde0352b-5420-494a-bdee-0a7e5260e617',
    questionOrder: 3,
    readableId: FOOTBALL_TYPE_ID,
    type: 'multi_optional',
    // title: {
    //   [MYSELF]: 'What are you interested in playing?',
    //   [SOMEONE_ELSE]: 'What are they interested in playing?',
    // },
    title: 'What are you interested in playing?',
    helpText:
      'Sessional football that is not part of a competition, its non-comital, play based on your lifestyle.',
    helpTextSecondary:
      'Team-based football included training, games and competitions with a set start and end date.',
    multiOptional: {
      mandate: [
        {
          answerId: 5,
          analyticsId: 'casual_football',
          title: 'Sessional',
          answerType: 'primary',
          value: CLUB_CASUAL,
          image: publicPath('/images/common/cutouts/kickabout.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
      ],
    },
    answers: {
      mandatory: [
        {
          answerId: 1,
          analyticsId: 'kickabout_football',
          title: 'Sessional',
          value: KICKABOUT_CASUAL,
          answerType: 'primary',
          image: publicPath('/images/common/cutouts/casual-girl.png'),
          keylineVariant: 2,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
        {
          answerId: 2,
          analyticsId: 'club_football',
          title: 'Team',
          value: CLUB,
          answerType: 'primary',
          image: publicPath('/images/common/cutouts/club-girl.png'),
          keylineVariant: 3,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
            },
          ],
        },
      ],
      optional: {
        answerId: 3,
        analyticsId: 'mixed_football',
        title: 'Mixed football',
        answerType: 'primary',
        value: CLUB_CASUAL,
        image: publicPath('/images/common/cutouts/mixed-adult.png'),
        ageRanges: [
          {
            min: 0,
            max: 0,
            nextQuestionId: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
          },
        ],
      },
    },
  },
];
